<template>
    <kgr-form-scaffold
        :pending="pending"
        @primaryBtnClicked="addDepartment"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-department-create-form
            :club-id="clubId"
            :department="department"
            :error="error"
            @enter="addDepartment"
        />
    </kgr-form-scaffold>
</template>

<script>
import Department from '../../js/dto/Department';
import DepartmentRepository from '../../js/repository/DepartmentRepository';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import KgrDepartmentCreateForm from '../../components/departments/DepartmentCreateForm';

export default {
    components: {
        KgrDepartmentCreateForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            department: new Department(),
            error: new Error(),
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        addDepartment() {
            this.pending = true;

            DepartmentRepository.create(this.department, this.clubId)
                .then((id) => {
                    this.$notify.success('Abteilung erfolgreich hinzugefügt', {}, { saveInSession: true });
                    window.location = `/backend/clubs/departments/${id}/basicData`;
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
